/* ==========================================================================
   Kuji Card Prizes
   Zeigt die ersten vier Preisbilder (A–D) unter dem Banner einer Kuji-Karte.

   Die Preisbilder stehen nicht in Shopify: jedes Kuji-Produkt hat dort nur
   das Banner. Die Bilder liegen in der Lottery-App und müssen deshalb
   clientseitig nachgeholt werden — aber erst, wenn eine Karte wirklich ins
   Sichtfeld kommt. Beendete Kuji sind in der Ansicht "Aktive" ausgeblendet
   und lösen dadurch von selbst keinen Abruf aus.
   ========================================================================== */
(function () {
  'use strict';

  /* Das Snippet rendert pro Karte, also steht das <script> mehrfach in der
     Seite. Der Browser lädt die Datei trotzdem nur einmal, führt sie aber je
     Tag aus — ab dem zweiten Mal ist hier Schluss. */
  if (window.__kujiPrizesBooted) return;
  window.__kujiPrizesBooted = true;

  /* Vier Ränge. Ab D wird der Inhalt gemischt — mal Hauptfigur, mal Chibi,
     mal Merch —, die Kachel zeigt also nicht mehr zwingend eine Figur. Sie
     bleibt trotzdem drin, weil sie die Tiefe eines Sets sichtbar macht: es
     geht nicht um drei Preise, sondern um eine ganze Stufenleiter. */
  var COUNT = 4;
  var MAX_PARALLEL = 4;
  var CACHE_TTL = 15 * 60 * 1000;
  var CACHE_PREFIX = 'kjp:';

  var queue = [];
  var running = 0;
  var observer = null;

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Die Bilder werden bewusst unverändert geladen, ohne Resize-Proxy.
     Gemessen über die 14 laufenden Kuji (42 Bilder, Stand 03.08.2026):
     87 KB im Schnitt, 261 KB pro Karte, 479 KB im schlimmsten Fall. Die
     aktuellen Sets liefern längst fertiges WebP über kuji-wiki-pics; nur
     ältere Einträge liegen noch auf dem App-Server. Ein Proxy würde das auf
     rund 25 KB je Karte drücken, dafür aber einen Dritt-Dienst in jede
     Seitenansicht holen (DSGVO) und in Umgebungen scheitern, die ihn
     blockieren. Der Gewinn wiegt das nicht auf.

     Sollten wieder Sets mit 1-MB-PNGs auftauchen, gehören Thumbnails in die
     Lottery-App — nicht ein Umweg in dieses Theme. */
  function imageUrl(base, file) {
    if (!file) return '';
    if (/^https?:\/\//i.test(file)) return file;
    return base + '/storage/app/public/lottery_first/' + file;
  }

  /* ------------------------------------------------------------- Zwischenspeicher */

  /* Beim Blättern zwischen Kategorie- und Produktseite würde sonst jede
     Rückkehr dieselben Abrufe auslösen. sessionStorage kann gesperrt sein
     (privater Modus, volles Kontingent) — jeder Zugriff bleibt deshalb
     optional. */
  function cacheRead(id) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + id);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || Date.now() - entry.t > CACHE_TTL) return null;
      return entry.p;
    } catch (err) {
      return null;
    }
  }

  function cacheWrite(id, prizes) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + id, JSON.stringify({ t: Date.now(), p: prizes }));
    } catch (err) {
      /* Kontingent voll oder Speicher gesperrt — der Abruf funktioniert auch ohne. */
    }
  }

  /* --------------------------------------------------------------- Darstellung */

  function render(el, prizes) {
    if (!prizes || !prizes.length) {
      el.remove();
      return;
    }

    /* Die Vorschau ist Beiwerk: Serie, Titel, Ticketstand, Preis und der
       "Jetzt ziehen"-Knopf sagen bereits alles, und die vollständige
       Preisliste steht auf der Produktseite. Vier zusätzliche Bildansagen
       pro Karte würden eine Liste mit über 100 Kuji nur zumüllen — der
       Streifen ist deshalb per aria-hidden im Snippet ausgenommen und die
       Bilder tragen ein leeres alt. */
    el.innerHTML = prizes
      .map(function (prize) {
        return (
          '<div class="kuji-prize">' +
          '<img src="' +
          esc(prize.img) +
          '" alt="" loading="lazy" decoding="async">' +
          '</div>'
        );
      })
      .join('');

    el.classList.add('is-ready');
  }

  /* Ein einzelnes totes Bild soll nicht als graue Kachel stehen bleiben.
     error blubbert nicht, deshalb die Capture-Phase am Container. */
  function bindFallback(el) {
    el.addEventListener(
      'error',
      function (event) {
        var img = event.target;
        if (!img || img.tagName !== 'IMG') return;
        var tile = img.parentNode;
        if (tile && tile.parentNode) tile.parentNode.removeChild(tile);
        if (!el.querySelector('.kuji-prize')) el.remove();
      },
      true
    );
  }

  /* -------------------------------------------------------------------- Abruf */

  function parsePrizes(data) {
    var details = [];
    try {
      details = JSON.parse(data.f_details || '[]');
    } catch (err) {
      details = [];
    }
    if (!Array.isArray(details)) return [];

    return details
      .slice(0, COUNT)
      .map(function (item) {
        return { img: imageUrl(data.base, item.f_image || item.image_url) };
      })
      .filter(function (prize) {
        return !!prize.img;
      });
  }

  function next() {
    if (running >= MAX_PARALLEL) return;
    var job = queue.shift();
    if (!job) return;
    running++;
    job(function () {
      running--;
      next();
    });
  }

  function enqueue(el) {
    var id = el.getAttribute('data-product-id');
    var base = el.getAttribute('data-api-base');
    if (!id || !base) {
      el.remove();
      return;
    }

    var cached = cacheRead(id);
    if (cached) {
      render(el, cached);
      return;
    }

    queue.push(function (done) {
      fetch(base + '/api/get-lottery-data/' + id)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (!response || !response.status || !response.data) {
            el.remove();
            return;
          }
          response.data.base = base;
          var prizes = parsePrizes(response.data);
          cacheWrite(id, prizes);
          render(el, prizes);
        })
        .catch(function () {
          /* Kein Netz, kein Eintrag in der Lottery-App: die Karte bleibt
             ohne Vorschau, statt eine leere Fläche zu zeigen. */
          el.remove();
        })
        .finally(done);
    });

    next();
  }

  /* ---------------------------------------------------------------- Beobachter */

  function ensureObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          enqueue(entry.target);
        });
      },
      { rootMargin: '300px 0px' }
    );
    return observer;
  }

  function scan() {
    var strips = document.querySelectorAll('.kuji-prizes:not([data-kjp-bound])');
    if (!strips.length) return;

    var io = ensureObserver();
    Array.prototype.forEach.call(strips, function (el) {
      el.setAttribute('data-kjp-bound', '');
      bindFallback(el);
      if (io) {
        io.observe(el);
      } else {
        enqueue(el);
      }
    });
  }

  /* Load-More hängt neue Karten an, ein Section-Render tauscht das ganze
     Grid aus. Beides landet unterhalb von .collection. */
  function watch() {
    var host = document.querySelector('.collection') || document.body;
    if (!host || !window.MutationObserver) return;

    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(scan, 120);
    }).observe(host, { childList: true, subtree: true });
  }

  function init() {
    scan();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scan);
})();
